





import {Component, Prop, Vue} from 'vue-property-decorator';

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component
export default class JdsAttributeListLayout extends Vue {
}
